import {pxToRem} from '../../utills/pxToRem'
import colors from '../../theme/foundations/colors'
import {fonts} from '../../theme/foundations/fonts'

export const pageContainerStyle = {
    padding: {
        base: `0 ${pxToRem(15)} ${pxToRem(30)} ${pxToRem(15)}`,
        md: `0 ${pxToRem(20)} ${pxToRem(60)} ${pxToRem(20)}`,
        xl: `0 ${pxToRem(20)} ${pxToRem(60)} ${pxToRem(20)}`,
        '2xl': `0 ${pxToRem(120)} ${pxToRem(60)} ${pxToRem(120)}`
    },
    margin: '0 auto'
}

export const headerStyle = {
    mt: pxToRem(42),
    mb: pxToRem(31.5),
    fontSize: pxToRem(21),
    fontFamily: fonts.primary,
    color: colors.cav_light_black,
    fontWeight: 700,
    textAlign: {base: 'center', md: 'start'},
    letterSpacing: {base: pxToRem(1), md: pxToRem(5)},
    lineHeight: {base: '31.5px'}
}

export const miniHeaderStyle = {
    fontSize: {base: pxToRem(18), xl: pxToRem(15.6)},
    fontFamily: fonts.primary,
    color: colors.cav_light_black,
    fontWeight: {base: 700, md: 400},
    textAlign: {base: 'center', md: 'right'},
    textTransform: 'uppercase',
    width: {md: pxToRem(200)},
    minW: {md: pxToRem(140)},
    margin: {base: 0, md: `${pxToRem(-3)} ${pxToRem(20)} 0 0`, xl: `0 ${pxToRem(20)} 0 0`},
    letterSpacing: {base: pxToRem(1.12)},
    lineHeight: {base: pxToRem(31.5)}
}

export const miniHeaderStyleDesktop = {
    fontSize: pxToRem(15.6),
    fontFamily: fonts.primary,
    color: colors.cav_light_black,
    fontWeight: 400,
    textTransform: 'uppercase',
    width: {xl: pxToRem(200)},
    margin: `0 ${pxToRem(20)} 0 0`,
    textAlign: {xl: 'right'}
}

export const buttonStyle = {
    mt: pxToRem(10),
    bg: colors.cav_faq_anchor_red,
    fontSize: pxToRem(14),
    fontWeight: 700,
    color: colors.white,
    cursor: 'pointer',
    fontFamily: fonts.primary,
    letterSpacing: pxToRem(1),
    lineHeight: pxToRem(18),
    width: '100%',
    borderRadius: 'none',
    textTransform: 'uppercase',
    py: pxToRem(9.8),
    _hover: {bg: colors.cav_hover_brightred}
}

export const minitextStyle = {
    textAlign: {base: 'center', md: 'start'},
    fontSize: pxToRem(12),
    fontFamily: fonts.primary,
    color: colors.cav_light_black,
    letterSpacing: pxToRem(1),
    lineHeight: pxToRem(18),
    margin: 0
}

export const textStyle = {
    p: {
        fontSize: pxToRem(12),
        fontFamily: fonts.primary,
        color: colors.cav_light_black,
        letterSpacing: pxToRem(1),
        lineHeight: pxToRem(18),
        mb: pxToRem(12)
    }
}

export const tableHeaderStyle = {
    fontWeight: 400,
    fontSize: pxToRem(12),
    fontFamily: fonts.primary,
    color: colors.cav_light_black,
    letterSpacing: pxToRem(1),
    lineHeight: pxToRem(18),
    margin: 0,
    padding: {base: pxToRem(7), md: `0 0 ${pxToRem(7)} 0`},
    textTransform: 'uppercase',
    width: {base: pxToRem(30), md: pxToRem(150), xl: pxToRem(80)},
    textAlign: 'left'
}

export const tableBodyStyle = {
    fontWeight: 400,
    fontSize: pxToRem(12),
    fontFamily: fonts.primary,
    color: colors.cav_light_black,
    letterSpacing: pxToRem(1),
    lineHeight: pxToRem(18),
    margin: 0,
    padding: {base: pxToRem(6), md: `${pxToRem(3)} ${pxToRem(3)} ${pxToRem(3)} 0`},
    textTransform: 'uppercase',
    width: pxToRem(30),
    textAlign: 'left'
}

export const streetMapMobileHeaderStyle = {
    ...miniHeaderStyle,
    my: {base: '10px', md: 0},
    mt: {md: '-7px'}
}

export const streetMapMobileButtonStyle = {
    ...buttonStyle,
    w: {base: '100%', md: '337px'}
}

export const addressHeaderStyle = {
    ...miniHeaderStyle,
    mt: {md: '-5px', xl: '-6px'}
}

export const addressContainerStyle = {
    display: {md: 'flex'},
    flexDirection: {md: 'row'}
}

export const addressTextContainerStyle = {
    display: {md: 'flex'},
    flexDirection: {md: 'column'}
}

export const phoneHeaderStyle = {
    ...miniHeaderStyle,
    mt: {md: '-6.5px', xl: '-6.5px'}
}

export const phoneContainerStyle = {
    display: {md: 'flex'},
    flexDirection: {md: 'row'}
}

export const storeHoursHeaderStyle = {
    ...miniHeaderStyle,
    mt: {md: '-7px', xl: '-4px'}
}

export const storeHoursContainerStyle = {
    display: {md: 'flex'},
    flexDirection: {md: 'row'}
}

export const tableContainerStyle = {
    mb: {base: '30px', xl: 0}
}

export const tableWrapperStyle = {
    maxW: {base: '100%', xl: '400px'},
    mt: {xl: '2.5px'}
}

export const tableDayStyle = {
    ...tableBodyStyle,
    fontWeight: 700,
    width: {xl: '100px'}
}

export const streetMapDesktopContainerStyle = {
    display: {base: 'none', xl: 'flex'},
    mb: {xl: '60px'}
}

export const streetMapDesktopHeaderStyle = {
    ...miniHeaderStyleDesktop,
    mt: '-5px',
    minW: '140px',
    flexShrink: 0
}

export const streetMapDesktopMapStyle = {
    ratio: 1.19,
    w: '475px'
}

export const streetMapDesktopButtonStyle = {
    ...buttonStyle,
    mt: 3,
    w: '475px'
}

export const aboutContainerStyle = {
    display: {md: 'flex'},
    mb: {md: '10px'}
}

export const aboutHeaderStyle = {
    ...miniHeaderStyle,
    my: '10px',
    mt: {md: '-5px', xl: '-5px'},
    flexShrink: 0
}

export const storeServiceContainerStyle = {
    display: {md: 'flex'}
}

export const storeServiceHeaderStyle = {
    ...miniHeaderStyle,
    mb: {base: '10px'},
    mt: {md: '-6px', xl: '-6px'},
    flexShrink: 0
}
